import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  List,
  ListItem,
  Text,
  useToast,
} from '@chakra-ui/react';
import { createSkill } from '../../../api/skills';

interface AddSkillsModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: (newSkills: { id: number; name: string }[]) => void;
  newSkills: string[];
}

export const AddSkillsModal: React.FC<AddSkillsModalProps> = ({
  visible,
  onClose,
  onConfirm,
  newSkills,
}) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      const response = await createSkill({ words: newSkills });
      onConfirm(response.data);
      toast({
        title: 'Навыки успешно добавлены',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: 'Ошибка при добавлении навыков',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      console.error('Ошибка при добавлении навыков:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={visible} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Новые навыки</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4}>Следующие навыки не найдены в справочнике:</Text>
          <List spacing={3}>
            {newSkills.map((skill, index) => (
              <ListItem key={index}>{skill}</ListItem>
            ))}
          </List>
          <Text mt={4} color="gray.500" fontSize="sm">
            При отмене будут выбраны только существующие навыки из справочника
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Отмена
          </Button>
          <Button 
            colorScheme="blue" 
            onClick={handleConfirm}
            isLoading={isLoading}
            loadingText="Добавление..."
          >
            Добавить в справочник
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}; 